import React from 'react';
import { Box } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { WeekdayImpactData } from './types';
import { getSerenityColor } from '../../utils/serenityColors';
import { useTranslation } from 'react-i18next';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface WeekdayImpactProps {
  data: WeekdayImpactData[];
}

const WeekdayImpact: React.FC<WeekdayImpactProps> = ({ data }) => {
  const { t } = useTranslation();

  const chartData = {
    labels: data.map(item => item.day),
    datasets: [
      {
        label: t('statistics.weekdayImpact.serenity'),
        data: data.map(item => item.serenityScore),
        backgroundColor: data.map(item => getSerenityColor(item.serenityScore)),
        borderRadius: 45,
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.7)'
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.7)',
          callback: (value: any) => {
            return t(`statistics.weekdayImpact.days.${value}`);
          }
        }
      }
    }
  } as const;

  return (
    <Box sx={{ height: '300px' }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
};

export default WeekdayImpact;
